import videojs from 'video.js';

let showcaseShareButtonRegistered = false;

const SHARE_GLYPH = `<span class="fc-vjs-showcase-share__glyph" aria-hidden="true">
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
  <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.26.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/>
</svg>
</span>`;

/** Przycisk udostępniania w chrome showcase (Video.js) — rejestracja jednorazowa. */
export function registerFcVjsShowcaseShareButton(): void {
  if (showcaseShareButtonRegistered) {
    return;
  }
  showcaseShareButtonRegistered = true;

  const Button = videojs.getComponent('Button');

  class ShowcaseShareButton extends Button {
    constructor(player: ReturnType<typeof videojs>, options?: Record<string, unknown>) {
      super(player, options);
      this.controlText('Udostępnij');
      this.addClass('fc-vjs-showcase-share');
      const el = this.el();
      if (el) {
        el.innerHTML = SHARE_GLYPH;
      }
    }

    override buildCSSClass(): string {
      return `fc-vjs-showcase-share ${super.buildCSSClass()}`;
    }

    override handleClick(): void {
      const url = window.location.href;
      const title = document.title;
      if (typeof navigator.share === 'function') {
        void navigator.share({ url, title }).catch(() => {
          void navigator.clipboard?.writeText(url);
        });
      } else if (navigator.clipboard?.writeText) {
        void navigator.clipboard.writeText(url);
      }
    }
  }

  videojs.registerComponent('ShowcaseShareButton', ShowcaseShareButton);
}
